import React, { SVGProps } from 'react';

export default function FastForwardIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="25"
      viewBox="0 0 40 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M6.3962 22.9656L6.41518 22.9548L18.1895 16.0974V20.2714C18.1895 21.133 18.4438 21.9566 19.031 22.5754C19.6195 23.1955 20.3986 23.4567 21.1416 23.4567C21.783 23.4567 22.3919 23.2686 22.9299 22.9656L22.9489 22.9548L35.7655 15.4904L35.7669 15.4896C36.2666 15.1978 36.7732 14.8564 37.1494 14.4039C37.5832 13.8821 37.7856 13.2867 37.7856 12.6391C37.7856 11.9915 37.5832 11.3961 37.1494 10.8743C36.7732 10.4218 36.2666 10.0804 35.7669 9.78861L35.7655 9.78779L22.9489 2.32341L22.93 2.31256C22.3918 2.00954 21.783 1.82153 21.1416 1.82153C20.3986 1.82153 19.6195 2.08267 19.031 2.7028C18.4438 3.32158 18.1895 4.14522 18.1895 5.00678V9.18081L6.41518 2.32341L6.39623 2.31256C5.849 2.00444 5.22714 1.82153 4.59495 1.82153C3.85193 1.82153 3.07284 2.08266 2.48432 2.70279C1.89709 3.32156 1.64282 4.1452 1.64282 5.00678V20.2714C1.64282 21.133 1.89709 21.9566 2.48432 22.5754C3.07284 23.1955 3.85192 23.4567 4.59495 23.4567C5.2272 23.4567 5.84904 23.2737 6.3962 22.9656Z"
        fill="white"
        stroke="black"
        strokeWidth="3"
        strokeLinejoin="round"
      />
    </svg>
  );
}
